const merchantCard = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '300px',
    width: '100%',
    gap: '2px',
    '& > .MuiTypography-body1': {
        color: 'secondary.dark',
    },
};
const truncate2Lines = {
    minHeight: '43px',
    maxHeight: '43px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkitLineClamp': '2' /* number of lines to show */,
    lineClamp: '2',
    '-webkitBoxOrient': 'vertical',
};
const greenChip = {
    border: '3px solid #44A56B',
};
const yellowChip = {
    border: '3px solid #FFB600',
};
const iconButton = {
    color: 'primary.main',
    whiteSpace: 'nowrap',
};
const cardContainer = {
    boxShadow: 'none',
    border: '2px solid #EEE',
    borderRadius: '8px',
    padding: {
        desktop: '24px',
        mobile: '18px',
    },
    width: '100%',
};
export default {
    merchantCard,
    greenChip,
    yellowChip,
    iconButton,
    cardContainer,
    truncate2Lines,
};
